<form class="row"
      novalidate
      [formGroup]="form"
      (keyup.enter)="submit()"
>
  <div class="col-12">
    <div class="p-field">
      <div class="p-field__title">
        <label class="text--md" for="input-email">Email</label>
        <app-icon-feather *ngIf="email.valid" icon="check-circle"></app-icon-feather>
        <app-icon-feather *ngIf="email.dirty && email.invalid" icon="x-circle"></app-icon-feather>
      </div>
      <input id="input-email"
             type="text"
             pInputText
             placeholder="your@email.com"
             name="email"
             [formControl]="email"
      >
      <div class="position-relative">
        <small class="p-error"
               *ngIf="email.dirty && email.invalid"
        >
          {{ getErrorMessage('Email', email) }}
        </small>
      </div>
    </div>
    <div class="p-field">
      <div class="p-field__title">
        <label class="text--md" for="input-password">Password</label>
        <app-icon-feather *ngIf="password.valid" icon="check-circle"></app-icon-feather>
        <app-icon-feather *ngIf="password.dirty && password.invalid" icon="x-circle"></app-icon-feather>
      </div>
      <div class="password-input-wrap">
        <input id="input-password"
               pInputText
               placeholder="***************"
               autocomplete="off"
               name="password"
               [type]="passwordType"
               [formControl]="password"
        >
        <app-toggle-password-visibility [(inputType)]="passwordType"></app-toggle-password-visibility>
      </div>
      <div class="position-relative">
        <small class="p-error"
               *ngIf="password.dirty && password.invalid"
        >
          {{ getErrorMessage('Password', password) }}
        </small>
      </div>
    </div>
  </div>

  <div class="col-12">
    <div class="mt-4 pt-3">
      <a class="p-link"
         routerLink="/auth/password-restore"
      >
        Forgot your password?
      </a>
    </div>
  </div>

  <div class="col-12 mt-5">
    <button pButton
            class="p-button-md w-100"
            type="button"
            label="LOGIN"
            [disabled]="form.invalid"
            (click)="submit()"
    ></button>
  </div>

  <div class="col-12 mt-3">
    <div class="divider">
      <span>or</span>
    </div>
  </div>

  <div class="col-12">
    <button pButton
            class="p-button-outlined p-button-info w-100"
            type="button"
            label="SCAN MOLST QR CODE"
            icon="pi pi-qrcode"
            (click)="onScanMolstQR()"
    ></button>
    <p class="text-center mt-2 text-muted small">
      Quick access to patient MOLST forms without login
    </p>
  </div>

  <div class="col-12">
    <div class="d-flex align-items-center justify-content-between flex-wrap">
      <p class="mt-3">
        Need an account?
        <a class="p-link"
           routerLink="/auth/select-role"
        >
          Register
        </a>
      </p>
      <p class="mt-3">
        <a class="p-link"
           routerLink="/auth/login"
        >
          <app-icon
            icon="i-9"
            width="24"
            height="24"
            tooltipPosition="left"
            pTooltip="Biometric login"
          ></app-icon>
        </a>
      </p>
    </div>
  </div>
</form>
